import * as React from 'react';
import { connect } from 'react-redux';
import authActions from './authActions';
import policyActions from '../policy/policyActions';
import { bindActionCreators } from 'redux';
import { Button } from '../components/buttons';
const classNames = require('classnames');

interface Props {
	currentUser: UserDetails;
	className?: string;
	actions: any;
	onClick: () => void;
}

class LoginWelcome extends React.Component<Props, {}> {
	logout = (e: any) => {
		this.props.actions.resetCustomerPolicy();
		this.props.actions.logout();
		this.props.onClick();
	}
	login = (e: any) => {
		this.props.actions.login();
	}

	render() {
		let content: any;
		if (this.props.currentUser.isAuthenticated) {
			content = (
				<div className="navbar-account-content">
					<strong className="navbar-account-username align-middle">{this.props.currentUser.fullName}</strong>
					<Button onClick={this.logout} className="btn btn-link text-tertiary text-uppercase nav-link">
						<strong>Log out</strong>
					</Button>
				</div>
			);
		} else {
			content = (
				<div className="nav-item">
					<Button onClick={this.login} className="btn btn-link text-tertiary text-uppercase nav-link">
						<strong>Log In</strong>
					</Button>
				</div>
			);
		}

		return (
			<div
				className={classNames('navbar-nav navbar-account', this.props.className, {
					'navbar-account-auth': this.props.currentUser.isAuthenticated
				})}
			>
				{content}
			</div>
		);
	}
}

function mapStateToProps(state: any) {
	return {
		currentUser: state.auth.currentUser
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...authActions, ...policyActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(LoginWelcome);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/auth/LoginWelcome.tsx